import styled, { css } from 'styled-components';

import { mediaQuery, H1 } from '@catalyze/ui';

export const StyledH1 = styled(H1)`
    margin: 1rem 0 2.5rem 0;
    font-size: ${({ theme }) => theme.fontSizes[8]};
    ${mediaQuery(
        2,
        css`
            display: none;
        `
    )};
`;

export const LoadingContainer = styled.div`
    margin-top: 300px;
    text-align: center;
`;
